import React from 'react';
import {Clock, Mail} from "lucide-react"
import "../styles/cardStyles.css";

function SiteownerCard() {
  return (
    <div className="card w-full max-w-sm border rounded-xl bg-white px-4 py-4 shadow-xl">
      <div className="cardHeader px-4">
        <Clock className="cardHeader__icon text-blue-600"/>
        <h3 className="text-2xl font-semibold">For Site Owners</h3>
      </div>
      <p className="text-sm text-slate-500 px-4">Steps to restore your website.</p>
      <ol className="cardList numberedList text-slate-600">
        <li>Contact your hosting provider immediately</li>
        <li>Verify your account status and billing information</li>
        <li>Follow the reactivation process provided</li>
      </ol>
      <a className="cardButton" href="mailto:matt@mataodesigns.com"><Mail className="cardButton__icon" />Contact Support</a>
    </div>
  );
}

export default SiteownerCard;